// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b7c01096","271":"7b9c11c8","339":"cef7af42","358":"9015af6e","399":"bfc2ed78","498":"ca869461","538":"11edf6b4","703":"772aa214","787":"9e9f4ffd","968":"98cb406d"}[chunkId] + ".chunk.js";
};